export type Region = 'eea-uk' | 'us' | 'us-ca' | 'us-va' | 'us-co' | 'us-ct' | 'us-ut' | 'row';

const LS_KEY = 'cmp.region.override';

let cached: Region | null = null;

export function initRegion(initial?: Region | null) {
  try {
    const raw = localStorage.getItem(LS_KEY);
    const stored = (raw as Region | null) ?? null;
    cached = stored ?? initial ?? null;
    if (cached) (window as unknown as { __cmpRegion?: Region }).__cmpRegion = cached;
  } catch {
    cached = initial ?? null;
    if (cached) (window as unknown as { __cmpRegion?: Region }).__cmpRegion = cached;
  }
}

export function getRegion(): Region | null {
  return cached ?? (window as unknown as { __cmpRegion?: Region }).__cmpRegion ?? null;
}

export function setRegion(region: Region) {
  cached = region;
  (window as unknown as { __cmpRegion?: Region }).__cmpRegion = region;
}

export function clearRegionOverride() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}

export function overrideRegionForDev(region: Region) {
  try {
    localStorage.setItem(LS_KEY, region);
  } catch {
    /* ignore */
  }
  setRegion(region);
}
